import { render, staticRenderFns } from "./GdprDialog.vue?vue&type=template&id=daadc85a&scoped=true"
import script from "./GdprDialog.vue?vue&type=script&lang=js"
export * from "./GdprDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daadc85a",
  null
  
)

export default component.exports